import React from "react";

export default function App() {
  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      backgroundColor: "#fff",
      fontFamily: "'Apple SD Gothic Neo', 'Noto Sans KR', sans-serif",
      color: "#1a1a1a",
      fontSize: "16px",
    }}>
      현재 웹사이트는 폐쇄되었습니다.
    </div>
  );
}
